import { render } from "./basicData.vue?vue&type=template&id=6cadf29b&scoped=true"
import script from "./basicData.vue?vue&type=script&lang=js"
export * from "./basicData.vue?vue&type=script&lang=js"

import "./basicData.vue?vue&type=style&index=0&id=6cadf29b&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cadf29b"]])

export default __exports__